export default (state = [], { type, payload, is_readyonly }) => {
  //console.log('payload ', payload);
  switch (type) {
    case 'ADD_ITEM':
      return { ...payload };
    case 'DELETE_ITEM':
      return { ...payload };
    case 'SUCESS':
      return { sucess: true };
    case 'IS_READONLY':
      return { ...state, is_readyonly: is_readyonly };
    case 'RESET_ITEM':
      return {};
    default:
      return state;
  }
};
